import React from 'react'
import { Table, Input } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../../../lib/moment.js'
import get from 'lodash/get'
import find from 'lodash/find'
import shortid from 'shortid'
import TrashDefault from '../../../../static/images/trash-default.svg'
import TrashHover from '../../../../static/images/trash-hover.svg'
import { attachment_table_header } from '../../constants'
import { FONTS } from '../../../../constants'

export default class AttachmentTable extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (JSON.stringify(nextProps) === JSON.stringify(this.props)) return false
    return true
  }

  filterAttach = (element) => {
    const search_attach = get(this.props, 'search_attach', '')
    if (search_attach !== '' && element) {
      const name = element.name.toLowerCase()
      const description = element.description.toLowerCase()
      return name.includes(search_attach.toLowerCase())
      || description.includes(search_attach.toLowerCase())
    } return element
  }

  findUploadedBy = (id) => {
    const emp = find(get(this.props, 'employees', []), {
      _id: id,
    })
    return emp ? `${emp.first_name} ${emp.last_name}` : '-'
  }

  render() {
    const editAttachment = get(this.props, 'editAttachment')
    const projectByID = get(this.props, 'projectByID')
    const presale_snapshot = get(projectByID, 'presale_snapshot.snapshot')
    const rSelected = get(this.props, 'rSelected')
    const isPresale = presale_snapshot && rSelected === 1
    const attachments = !isPresale ? get(this.props, 'attachments', []) : get(presale_snapshot, 'attachments')
    const deleteAttachment = get(this.props, 'deleteAttachment')
    const handleChangeCost = get(this.props, 'handleChangeCost')
    return (
    /* eslint no-underscore-dangle: 0 */
      <Root>
        <NewTable bordered>
          <Header>
            <tr style={ { fontFamily: 'Gotham' } }>
              { attachment_table_header.map(v => {
                  return (
                    <th key={ shortid() }>{ v.label }</th>
                  )
                })
              }
            </tr>
          </Header>
          <BodyTable>
            { attachments.filter(this.filterAttach).map((attachment, key) => {
                  return (
                    <tr key={ shortid() }>
                      <td>
                        <a href={ attachment.url }>{ attachment.name }</a>
                      </td>
                      <td>
                        <InputField
                          id={ key }
                          name='description'
                          disabled={ !editAttachment }
                          defaultValue={ attachment.description }
                          onBlur={ (e) => handleChangeCost(e) }
                        />
                      </td>
                      <td>
                        { this.findUploadedBy(attachment.created_by) }
                      </td>
                      <td>
                        { moment(attachment.created).format('DD/MM/YYYY') }
                      </td>
                      <td>
                        <Trash
                        onClick={
                          editAttachment?
                            () => deleteAttachment(key)
                            : () => { }
                        }
                        edit={editAttachment}
                      />
                      </td>
                    </tr>
                  )
                // }
              })
            }
          </BodyTable>
        </NewTable>
      </Root>
    )
  }
}

const Root = styled.div`
  margin-top: 10px;
  
  @media (max-width: 575.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width: 100vw;
    overflow: scroll;
  }

  @media (max-width: 767.98px) {
    padding-right: 0px;
    padding-left: 0px;
    font-size: 12px;
    width: 100vw;
    overflow: scroll;
  }
`

const NewTable = styled(Table)`
  thead, tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  } thead th {
    background: #404040;
    font-family: ${FONTS.GOTHAM_MEDIUM} !important;
    font-size: ${FONTS.SMALL_SIZE};
    border : none;
  }

  @media (max-width: 575.98px) {
    width: 800px;

    thead, tbody tr{
      display: table;
      width: 100%;
      table-layout: fixed;
      font-family: ${FONTS.GOTHAM} !important;
      font-size: ${FONTS.SMALL_SIZE};
    }
    td {
      padding-left: 1%;
    }
    th {
        padding-left: 1%;
      }
    }
    @media (max-width: 767.98px) {
      width:800px;

      td {
        padding-left: 1%;
      }
      th {
        padding-left: 1% ;
      }
  }
  @media (max-width: 991.98px) {
      width:800px;

      td {
        padding-left: 1%;
      }
      th {
        padding-left: 1% ;
      }
  }
`

const BodyTable = styled.tbody`
  width: 100%;
  display: block;
  overflow-y: scroll;
  background: #FFFFFF;

  ::-webkit-scrollbar {
    display: none;
  }
`

const Header = styled.thead`
  background: black;
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
`

const InputField = styled(Input)`
  font-family: ${FONTS.GOTHAM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  width : 100%;
  height : 100%;
`

const Trash = styled.div`
  background-image: ${props => {
  const edited = props.edit
    if (edited) {
      return `url(${TrashHover})`
    }
    return `url(${TrashDefault})`
  }};
  background-repeat: no-repeat;
  align-self: center;
  border:0;
  width: 20px ;
  height: 20px ;
  margin: auto ;
  cursor: ${props => { return props.edit ? 'pointer' : 'default' }};
`



// WEBPACK FOOTER //
// ./src/components/project-information/table/table-attachment/index.js